import { render } from "./cookie.vue?vue&type=template&id=5a5ec4bb&scoped=true&ts=true"
import script from "./cookie.vue?vue&type=script&lang=ts"
export * from "./cookie.vue?vue&type=script&lang=ts"

import "./cookie.vue?vue&type=style&index=0&id=5a5ec4bb&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5ec4bb"]])

export default __exports__